import { apiClient } from './api-client'
import axios from 'axios'

export interface User {
  id: number
  name: string
  email: string
  email_verified_at?: string
  created_at: string
  updated_at: string
}

export interface AuthResponse {
  message: string
  user: User
  access_token: string
  token_type: string
}

export interface LoginCredentials {
  email: string
  password: string
}

export interface ChangePasswordData {
  current_password: string
  password: string
  password_confirmation: string
}

class AuthAPI {
  private baseURL = ''

  constructor() {
    // CSRF cookie will be handled by apiClient
    this.setCsrfCookie();
  }


  async setCsrfCookie(): Promise<void> {
    //csrf
    await apiClient.get('/csrf-cookie');
  }


  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    //csrf 
    const response = await apiClient.post(`${this.baseURL}/login`, credentials)
    return response.data
  }

  async logout(): Promise<void> {
      await apiClient.post(`${this.baseURL}/logout`)
  }

  async logoutAll(): Promise<void> {
      await apiClient.post(`${this.baseURL}/logout-all`)
  }

  async getUser(): Promise<{ user: User }> {
    const response = await apiClient.get(`${this.baseURL}/current-user`)
    return response.data
  }

  async refreshCurrentUser(): Promise<AuthResponse> {
    const response = await apiClient.post(`${this.baseURL}/refresh`)
    return response.data
  }

  async changePassword(data: ChangePasswordData): Promise<{ message: string }> {
    const response = await apiClient.post(`${this.baseURL}/change-password`, data)
    return response.data
  }

  async sendPasswordResetLink(email: string): Promise<{ message: string }> {
    const response = await apiClient.post(`${this.baseURL}/password/email`, { email })
    return response.data
  }

  async resetPassword(data: {
    token: string
    email: string
    password: string
    password_confirmation: string
  }): Promise<{ message: string }> {
    const response = await apiClient.post(`${this.baseURL}/password/reset`, data)
    return response.data
  }
}

export const authAPI = new AuthAPI()